type Options = {
  prefix?: boolean;
  decimalPlaces?: number;
};

export function priceFormat(price: number, options?: Options) {
  const { prefix = true, decimalPlaces } = options || {};

  const formattedPrice = price
    ? Number(price).toLocaleString("en-US", {
        minimumFractionDigits: decimalPlaces ?? 0,
        maximumFractionDigits: decimalPlaces ?? 0,
      })
    : "0";
  // return `${formattedPrice} ${prefix ? trans("sar") : ""}`;
  return (
    <span dir="rtl" className="flex-inline items-center gap-1">
      <span>{formattedPrice} </span>
      {prefix ? (
        <span className="icon-SR font-saudi-riyal font-medium leading-none"></span>
      ) : (
        // <span className="text-[1.2em] leading-none">{trans("sar")}</span>
        ""
      )}
    </span>
  );
}
